// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText_richText__Q_NS3","body-text":"RichText_body-text__6Qh0t"};